var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppstoreBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "45px",
    viewBox: "0 0 50 45",
    enableBackground: "new 0 0 50 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M12.559,38.381l0.006,0.002l-2.415,4.182c-0.882,1.527-2.834,2.051-4.36,1.168 c-1.527-0.881-2.05-2.834-1.168-4.359L6.4,36.291l0.171-0.295c0.305-0.439,1.057-1.195,2.562-1.053c0,0,3.542,0.385,3.798,2.225 C12.931,37.168,12.966,37.773,12.559,38.381L12.559,38.381z M46.808,27.697h-7.53c-0.512-0.035-0.736-0.217-0.824-0.324l-0.006-0.01 l-8.061-13.961l-0.01,0.007l-0.484-0.693c-0.792-1.211-2.05,1.887-2.05,1.887c-1.502,3.453,0.213,7.379,0.812,8.564L39.85,42.561 c0.882,1.525,2.834,2.049,4.36,1.168s2.05-2.834,1.169-4.361l-2.8-4.848c-0.055-0.117-0.149-0.438,0.425-0.438h3.804 c1.764,0,3.192-1.43,3.192-3.193C50,29.127,48.571,27.697,46.808,27.697L46.808,27.697z M32.182,32.037c0,0,0.402,2.045-1.152,2.045 h-1.556l0,0H3.192C1.429,34.082,0,32.652,0,30.889c0-1.762,1.429-3.191,3.192-3.191h7.157c1.155-0.066,1.429-0.734,1.429-0.734 l0.006,0.004l9.342-16.18l-0.003-0.001c0.17-0.312,0.028-0.608,0.004-0.654l-3.085-5.344c-0.882-1.526-0.358-3.479,1.168-4.36 c1.527-0.881,3.479-0.358,4.36,1.168l1.431,2.478l1.428-2.474c0.881-1.527,2.834-2.05,4.36-1.168s2.05,2.833,1.168,4.36 L18.959,27.307c-0.057,0.137-0.074,0.354,0.349,0.391h7.771l0.002,0.076C27.08,27.773,31.57,27.844,32.182,32.037z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreBlack);
export default __webpack_public_path__ + "static/media/appstoreBlack.315f73adbfc2ae8231cfabf0fdc93624.svg";
export { ForwardRef as ReactComponent };